module.exports = __webpack_public_path__ + "static/img/business17.2268d2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business17.jpg
// module id = 8HC5
// module chunks = 9